export const environment = {
  production: true,
  apiSolicitarProposta: "https://prod.api.firstdata.com/bwa/leads-management-api/api/v1/leads",
  reqId: 'b02c1222-8830-4877-a23d-8a0644c4bd47',
  apiKey: '73UwabXgrxehC4yVvnClWETAzrCU3r9J',
  apiSecret: '7Wpfw5thHGCX0uQFpfrVTViMBP5oA8JDWUivqGdonte',
  origin: location.hostname.includes('localhost') ? `https://azulzinhadacaixa.com.br`  : `https://${location.hostname}`,
};
